module.exports = __webpack_public_path__ + "static/media/290746.5866b15a.png";